import React from 'react'
import avatar1 from '../assets/avatar/avatar1.png'
import avatar2 from '../assets/avatar/avatar2.png'
import avatar3 from '../assets/avatar/avatar3.png'
import avatar4 from '../assets/avatar/avatar4.png'
import avatar5 from '../assets/avatar/avatar5.png'
import avatar6 from '../assets/avatar/avatar6.png'
import avatar7 from '../assets/avatar/avatar7.png'
import avatar8 from '../assets/avatar/avatar8.png'
import avatar9 from '../assets/avatar/avatar9.png'
import avatar10 from '../assets/avatar/avatar10.png'
import avatar11 from '../assets/avatar/avatar11.png'
import avatar12 from '../assets/avatar/avatar12.png'
import avatar13 from '../assets/avatar/avatar13.png'
import avatar14 from '../assets/avatar/avatar14.png'
import avatar15 from '../assets/avatar/avatar15.png'
import avatar16 from '../assets/avatar/avatar16.png'
import avatar17 from '../assets/avatar/avatar17.png'
import avatar18 from '../assets/avatar/avatar18.png'
import avatar19 from '../assets/avatar/avatar19.png'
import avatar20 from '../assets/avatar/avatar20.png'
import avatar21 from '../assets/avatar/avatar21.png'
import avatar22 from '../assets/avatar/avatar22.png'
import avatar23 from '../assets/avatar/avatar23.png'
import avatar24 from '../assets/avatar/avatar24.png'
import avatar27 from '../assets/avatar/avatar27.png'
import avatar28 from '../assets/avatar/avatar28.png'

import Update from '../assets/iconUpdate.svg'

import avatarUniSexe from '../assets/avatarUniSexe.svg'
import classNames from 'classnames'


const dataAvatar = [
    { index: 1, image: avatar1 },
    { index: 2, image: avatar2 },
    { index: 3, image: avatar3 },
    { index: 4, image: avatar4 },
    { index: 5, image: avatar5 },
    { index: 6, image: avatar6 },
    { index: 7, image: avatar7 },
    { index: 8, image: avatar8 },
    { index: 9, image: avatar9 },
    { index: 10, image: avatar10 },
    { index: 11, image: avatar11 },
    { index: 12, image: avatar12 },
    { index: 13, image: avatar13 },
    { index: 14, image: avatar14 },
    { index: 15, image: avatar15 },
    { index: 16, image: avatar16 },
    { index: 17, image: avatar17 },
    { index: 18, image: avatar18 },
    { index: 19, image: avatar19 },
    { index: 20, image: avatar20 },
    { index: 21, image: avatar21 },
    { index: 22, image: avatar22 },
    { index: 23, image: avatar23 },
    { index: 24, image: avatar24 },
    // { index: 25, image: avatarUniSexe },
    // { index: 26, image: avatarUniSexe },
    { index: 27, image: avatar27 },
    { index: 28, image: avatar28 },
    // { index: 25, image: avatarUniSexe },
  ]
interface Props{
    genre ? : string
    avatar : any
    border? : string
    styleCss?: string
    name? : string
    num? : string
    afficheName ? : boolean
    lastName? : string
    ifUpdate? : boolean
    shadow?:string
    setUpdateImageUser? :(value : boolean) => void
}

const Avatar : React.FC<Props> = ({avatar, border, styleCss, name, num,
  shadow, afficheName=false, genre,lastName, ifUpdate=false, setUpdateImageUser}) => {

    const matchedAvatar = dataAvatar.find((v) => v.index === avatar)
  return (
    
      <div className={`${border} ${afficheName ? 'flex w-full gap-6 xl:gap-4 items-center' : ' flex-col items-center justify-center '}`}>
        <div className={` ${shadow} overflow-hidden   ${ifUpdate && 'relative'}`} >

        <img className= {classNames( styleCss)} width={100} height={100}
         src={ matchedAvatar ? matchedAvatar?.image : avatarUniSexe }

            alt='avatar' >
        </img>
        {ifUpdate && 

         <div className="absolute bottom-0 left-0 w-full h-1/2 bg-[#5754E5] opacity-75 rounded-b-full flex items-center justify-center cursor-pointer"
         onClick={() => setUpdateImageUser && setUpdateImageUser(true)}
         
         >  
         <img  src={Update} alt=''/>
         </div>
         }
        </div>
        { afficheName ? 
          <div className='text-[18px] xl:text-[15px] '>
              <div className=" text-[#0A0A0A] text-[14px] font-medium "> {name}</div>
              <div className="text-[#B4B4B4] mt-[3px]">{num}</div>
          </div>
          :
          <div className=" text-[#0A0A0A] text-sm text-center xl:text-[12px] ">{lastName?.slice(0,6)}</div>
          
        }
      </div>

    
  )
}

export default Avatar
